module.exports = __webpack_public_path__ + "img/title-resource.1284a110.svg";